import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {CategoryBlock} from "@/models";

export class CategoryBlockService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetAll(query) {
        return this.baseApiFactory.get<CategoryBlock[]>('/api/CategoryBlock?' + query);
    }

    Add(data) {
        return this.baseApiFactory.post('/api/CategoryBlock/Add', data);
    }

    Update(data) {
        return this.baseApiFactory.put('/api/CategoryBlock/Update', data);
    }

    Delete(id) {
        return this.baseApiFactory.delete('/api/CategoryBlock/' + id);
    }
}

lazyRegister.service('CategoryBlockService', CategoryBlockService);